export class AuthError extends Error {}
